module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', [_vm._l((_vm.list), function(item) {
    return _c('p', [_vm._v("\n\t\t    Line:\n\t\t    "), _c('span', {
      domProps: {
        "textContent": _vm._s(item)
      }
    })])
  }), _vm._v(" "), _c('infinite-loading', {
    on: {
      "infinite": _vm.infiniteHandler
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa85bd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/test/Scroll.vue
// module id = 455
// module chunks = 0